import React from "react";
import "./landingsectionthree.css";

export default function LandingSectionThree() {
  return (
    <section className="outcomes-section">
      <div className="integrations-header">
        <h2>What Happens When You Stop Firefighting</h2>
        <p>
          When you stop firefighting, you start solving root problems, building
          systems that prevent chaos, and reclaiming time to focus on strategic
          growth.
        </p>
      </div>

      <div className="stats-grid">
        <div className="stat-box">
          <div className="stat-number">87%</div>
          <div className="stat-desc">less reactive work across teams</div>
          <div className="stat-proof">Measured across 60 days of usage</div>
        </div>
        <div className="stat-box">
          <div className="stat-number">19%</div>
          <div className="stat-desc">
            more captured growth from overlooked areas
          </div>
          <div className="stat-proof">Identified in quarterly OKR audits</div>
        </div>
        <div className="stat-box">
          <div className="stat-number">2.5×</div>
          <div className="stat-desc">
            faster strategic decisions company-wide
          </div>
          <div className="stat-proof">From PM tool decision timestamps</div>
        </div>
        <div className="stat-box">
          <div className="stat-number">92%</div>
          <div className="stat-desc">
            of flagged issues auto-mitigated with no meetings
          </div>
          <div className="stat-proof">Verified in team activity logs</div>
        </div>
        <div className="stat-box">
          <div className="stat-number">4 hrs</div>
          <div className="stat-desc">
            saved per manager per week on risk reviews
          </div>
          <div className="stat-proof">
            Compared to baseline manual workflows
          </div>
        </div>
        <div className="stat-box">
          <div className="stat-number">100%</div>
          <div className="stat-desc">
            alignment between risk and strategy teams
          </div>
          <div className="stat-proof">
            Self-reported in post-rollout surveys
          </div>
        </div>
      </div>

      <div className="quote-box">
        “Radar+ became our silent operator — surfacing issues and pushing
        fixes before we even saw the fire.”
        <span className="quote-attribution">– Head of Ops, Series B SaaS</span>
      </div>
    </section>
  );
}
